import {
  buildEcommerceEvent,
  createEcommercePayload,
  mapProductToItem,
  mapProductTypeToAnalyticsCategory,
} from "@/lib/analytics/ecommerce-analytics";
import { setItemListOrigin } from "@/lib/analytics/item-list-context";

import { EVENTS } from "@/constants/analytics.constants";
import type { useTagging } from "@/hooks/useTagging";

import type { ProductCardProduct } from "./productCard.component";

export const RECOMMENDED_PRODUCTS_ITEM_LIST_ID =
  "blu_homepage_featured_products";
export const RECOMMENDED_PRODUCTS_ITEM_LIST_NAME = "featured_products";

type SetTag = ReturnType<typeof useTagging>[1];

export function trackRecommendedProductSelect(
  product: ProductCardProduct,
  setTag: SetTag,
  index?: number,
) {
  setItemListOrigin({
    item_list_id: RECOMMENDED_PRODUCTS_ITEM_LIST_ID,
    item_list_name: RECOMMENDED_PRODUCTS_ITEM_LIST_NAME,
    item_id: product.id,
    item_slug: product.slug,
  });

  const item = mapProductToItem(
    {
      id: product.id,
      slug: product.slug,
      name: product.name,
      listPrice: product.listPrice,
      salesPrice: product.salesPrice,
      type: product.type,
    },
    {
      index,
      category: mapProductTypeToAnalyticsCategory(product.type, product.id),
    },
  );

  const payload = createEcommercePayload([item], {
    item_list_id: RECOMMENDED_PRODUCTS_ITEM_LIST_ID,
    item_list_name: RECOMMENDED_PRODUCTS_ITEM_LIST_NAME,
  });

  setTag(buildEcommerceEvent(EVENTS.SELECT_ITEM, payload), { reset: true });
}
